const defaultMenus = {};
export default defaultMenus;
